import React, { useState, useEffect } from "react";
import { UserStoryDto } from "../../dto/UserStoryDto";
import "./styles/DesktopWindow.css";

interface TextEditStoryWindowProps {
  story: UserStoryDto;
}

const TextEditStoryWindow = ({ story }: TextEditStoryWindowProps) => {
  const [lang, setLang] = useState<"EN" | "DE">("EN");
  const [content, setContent] = useState(story.textEN);

  useEffect(() => {
    setContent(lang === "EN" ? story.textEN : story.textDE);
  }, [lang, story.textEN, story.textDE]);

  return (
    <div className="osx-desktop-window text-editor-window">
      <div className="osx-desktop-window-titlebar">
        <div className="osx-desktop-window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <div className="osx-desktop-window-title text-editor-window">
          <div className="osx-desktop-window-title-content">
            {lang === "EN" ? story.titleEN : story.titleDE}
          </div>
        </div>
      </div>

      <div className="osx-desktop-window-lang-switcher">
        <button
          className={lang === "EN" ? "toggle-button active" : "toggle-button"}
          onClick={() => setLang("EN")}
        >
          English
        </button>
        <button
          className={lang === "DE" ? "toggle-button active" : "toggle-button"}
          onClick={() => setLang("DE")}
        >
          Deutsch
        </button>
      </div>

      <div className="osx-desktop-window-content text-editor-window">
        <textarea
          className="osx-desktop-window-editor"
          readOnly
          value={content}
        />
        {story.id === 99999 && (
          <img
            className="share-ipod-story"
            src="/assets/themes/ipod/ipod_share-story_qr.png"
            alt="Share Story"
          />
        )}
      </div>

      <div className="osx-desktop-window-footer">
        Selected language: {lang === "EN" ? "English" : "Deutsch"}
      </div>
    </div>
  );
};

export default TextEditStoryWindow;
